import { EventInterface } from "../../../../../shop/frontend/web/js/interfaces/EventInterface";
import { EventView } from "../views/EventView";
import { eventHelper } from "../../../../../shop/frontend/web/js/helpers/EventHelper";
import { EVENT_ORDER } from "../../../../../shop/frontend/web/js/constants/event";
import { helpers } from "../../../../../shop/frontend/web/js/helpers";
import { EventInteractPlan } from "../components/EventInteractPlan/EventInteractPlan";
import { EventOrderBottom } from "../components/EventOrderBottom/EventOrderBottom";
import api from "../../../../../shop/frontend/web/js/api";

class EventController extends EventInterface {
	constructor() {
		super();

		/* Объявляем компоненты */
		this.interactPlan = new EventInteractPlan();
		this.eventOrderBottom = new EventOrderBottom();

		/* Создаем представления */
		this.view = new EventView();

		this.isFreeSeatingPlan = false;

		/* Инициализация событии */
		super.initEventEmitter();
	}

	/* Инициализция подписчиков */
	setUpSubscribers() {
		/**
		 * Подписчик который срабатывает после загрузки мероприятия
		 * @event EventController#event:after-load-event
		 */
		this.emitter.subscribe("event:after-load-event", () => {
			/* добавляем в модель информацию об евенте */
			this.model.setEventId($("#js-places").data("event"));
			this.model.unitId = $("#js-svg").data("unit");

			if (window.location.pathname.includes("event") && !helpers.isDesktop.matches)
				this.view.showEventOnPopup();

			if (EVENT_ORDER)
				this.eventOrderBottom.updateOrder(EVENT_ORDER, this.model.getEventId());

			if (eventHelper.isStadiumPlan()) {
				return this.emitter.emit("event:load-stadium-plan");
			} else {
				return this.emitter.emit("event:load-scene-plan");
			}
		});

		/**
		 * Подписчик который нициализирует стадион
		 * @event EventController#event:load-stadium-plan
		 */
		this.emitter.subscribe("event:load-stadium-plan", () => {
			api.event.getZones({eventId: this.model.getEventId()}).then(res => {
				if (!res.zones) return alert("Не удалось получить ценовые зоны!");

				this.interactPlan.renderStadiumZones(res.zones);

				/* Обработчик для фильтра по легендам цен */
				$(".js-stadium-zones input[type=checkbox]").on("change", () =>
					this.interactPlan.renderSvgSectorsByPrices()
				);
			});

			/* Инициализируем работу с планом стадиона */
			this.interactPlan.initStadiumPlan({
				model: {
					eventId: this.model.getEventId(),
					unitId: this.model.unitId,
				},
				onLoadSector: () => {
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				},
				tapOnPlace: place => this.emitter.emit("event:tap-on-place", place),
			});
		});

		/**
		 * Подписчик который срабатывает после загрузки сцены, зала
		 * т.е свг план у которого нет секторов! (не стадион)
		 * @event EventController#event:load-scene-plan
		 * @property sceneData {Object} - {prices, zones}
		 */
		this.emitter.subscribe("event:load-scene-plan", () => {
			api.event.getPrices({eventId: this.model.getEventId(), viewId: this.model.currentViewId}).then(res => {
				if (!res.prices) return alert("Не удалось загрузить цены!");

				this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());

				this.interactPlan.initScenePlan({
					model: {
						eventId: this.model.getEventId(),
						unitId: this.model.unitId,
						prices: res.prices,
						zones: res.zones,
					},
					tapOnPlace: place => this.emitter.emit("event:tap-on-place", place),
				});

				/* проверка для плана(холла) со свободной рассадкой (выводить тултип и билет без "ряд место")  */
				this.isFreeSeatingPlan = $("g[mode=2]").length === 50;

				if ($("g#s1r1p1").find("tspan").text() === "Входной билет") {
					$("g#s1r1p1").attr("data-name", "Входной билет");
				}
				if (this.isFreeSeatingPlan) {
					$("g.active").attr("data-name", "Входной билет (свободная рассадка)");
				}

				$("#js-places").addClass("active");
				$("#js-places-info").removeClass("places__info_sector");
			});
		});

		/**
		 * При нажатии на активное место добавляет или удаляет из корзины и возвращает событие
		 * @event EventController#event:tap-on-place
		 * @property {SVGGElement} $activePlace
		 */
		this.emitter.subscribe("event:tap-on-place", $activePlace => {
			const sid = $activePlace.attr("id");

			/* Если место уже активное то удаляем из корзины */
			if ($activePlace.attr("data-available") === "false")
				return this.emitter.emit("event:remove-from-cart", sid);

			return this.emitter.emit("event:add-to-cart", sid);
		});

		/**
		 * Удаляет место из корзины
		 * @event EventController#event:remove-from-cart
		 */
		this.emitter.subscribe("event:remove-from-cart", sid => {
			return api.eventCart.removeFromCart({
				eventId: this.model.eventId,
				sid: sid,
				viewId: this.model.currentViewId
			})
				.then(res => {
					if (res.error) return alert("Произошла ошибка при удалении из корзины!");
					if (res.redraw)
						return alert("Данное место больше недоступно. Выберите другое. ");
					if (!res.carts) return false;

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();

					this.eventOrderBottom.removeActiveCarts(res.carts);
					this.interactPlan.removeActivePlaces(res.carts);

					if ($("g#s1r1p1").find("tspan").text() === "Входной билет") {
						$("g#s1r1p1").attr("data-name", "Входной билет");
					}
					if (this.isFreeSeatingPlan) {
						$("g.active").attr("data-name", "Входной билет (свободная рассадка)");
					}
				})
				.catch(err => alert("Произошла ошибка при удалении из корзины!"));
		});

		/**
		 * Подписчик который добавляет место в корзину
		 * @event EventController#event:add-to-cart
		 */
		this.emitter.subscribe("event:add-to-cart", sid => {
			api.eventCart.addToCart({
				eventId: this.model.eventId,
				sid: sid,
				viewId: this.model.currentViewId
			})
				.then(res => {
					if (res.need_auth) return alert("Необходима авторизация!");

					if (res.limit)
						return alert(
							"Вы превысили максимально допустимое количество мест для брони"
						);

					if (res.redraw)
						return alert("Данное место больше недоступно. Выберите другое. ");

					$("#js-places-limit").show();

					window.CartService.count = window.CartService.count + 1;
					window.CartService.updateCount();

					/* Выводим заказ */
					this.eventOrderBottom.updateOrder(res.order, this.model.getEventId());

					/* Показываем активные места на плане */
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());

					if ($("g#s1r1p1").find("tspan").text() === "Входной билет") {
						$("g#s1r1p1").attr("data-name", "Входной билет");
					}
					if (this.isFreeSeatingPlan) {
						$("g.active").attr("data-name", "Входной билет (свободная рассадка)");
					}
				})
				.catch(err => alert("Произошла ошибка при добавлении в корзину!"));
		});

		/**
		 * Делает запрос на очистку корзины
		 * @event EventController#event:clear-cart
		 */
		this.emitter.subscribe("event:clear-cart", () => {
			api.eventCart.removeEventFromOrder({eventId: this.model.eventId, orderId: this.eventOrderBottom.getOrderId()})
				.then(res => {
					if (res.error) return alert(res.msg ? res.msg : "Неизвестная ошибка!");

					if (res.refresh) return window.location.reload();

					if (!res.success) return alert("Произошла ошибка при очистке корзины!");

					/* Очищаем активные места на плане */
					this.interactPlan.removeActivePlaces(this.eventOrderBottom.getOrderCarts());

					/* Очищаем корзину */
					this.eventOrderBottom.clearOrder();
				})
				.catch(err => alert("Произошла ошибка при очистке корзины!"));
		});
	}

	/* Инициализция обработчиков */
	setUpListeners() {
		this.eventOrderBottom.on("clear", () => this.emitter.emit("event:clear-cart"));
		this.eventOrderBottom.on("remove-ticket", sid =>
			this.emitter.emit("event:remove-from-cart", sid)
		);
		this.eventOrderBottom.pane("show", () =>
			$("#js-places-change").css("padding-bottom", "138px")
		);
		this.eventOrderBottom.pane("hide", () => $("#js-places-change").css("padding-bottom", "0"));

		/* Инициализация страницы евента */
		this.emitter.emit("event:after-load-event");
	}
}

export const eventController = new EventController();
